import React, { FC } from 'react'
import { ErrorPage } from './ErrorPage'

export const Page_500Component: FC = () => {
	return (
		<ErrorPage
			advice="Перейдите на стартовую страницу, чтобы попробовать ещё раз или обратитесь в&nbsp;поддержку."
			errorCode={500}
			title="Происходит что-то странное, мы скоро все поправим..."
		/>
	)
}
